<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="marketplace_code"
                                       label="Marketplace Code"
                                       size="3"
                                       :isFocus="true"
                                       v-model:field="search.marketplace_code" />

                        <FormInputText fieldName="action"
                                       label="Action"
                                       size="3"
                                       v-model:field="search.action" />

                        <FormInputText fieldName="identity"
                                       label="Identity"
                                       size="3"
                                       v-model:field="search.identity" />

                        <FormInputText fieldName="status"
                                       label="Status"
                                       size="3"
                                       v-model:field="search.status" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="seller_id"
                                    label="Seller"
                                    size="6"
                                    :options="select?.sellers"
                                    :filter="(event) => onFilter(event, 'sellers')"
                                    v-model:field="search.seller_id" />

                        <FormInputText fieldName="message"
                                       label="Message"
                                       size="6"
                                       v-model:field="search.message" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from "@crud/FormInputText.vue";
import FormSelect from "@crud/FormSelect.vue";
import FormInputNumber from "@crud/FormInputNumber.vue";

import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

const options = ["sellers"];
const select = ref(null);

let search = ref({})

prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
